import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const PromoParagraphLoadable = loadable(() => import('./PromoParagraph'), {
  resolveComponent: components => components.PromoParagraph
});

export const PromoParagraph = WithLazyHydration(PromoParagraphLoadable, {
  name: 'PromoParagraph'
});
